// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-sheet[data-v-118561bc]{margin-bottom:120px}.hero6 .v-image[data-v-118561bc]{margin-top:-180px;top:240px}@media screen and (min-width:700px){.bg-sheet[data-v-118561bc]{margin-bottom:220px}.hero6 .v-image[data-v-118561bc]{margin-top:-240px;top:340px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
